import React from "react";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./lib/auth";

import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Prospects from "./pages/Prospects";
import Scripts from "./pages/Scripts";
import Campaigns from "./pages/Campaigns";
import CampaignDetail from "./pages/CampaignDetail";
import Calls from "./pages/Calls";
import CallDetail from "./pages/CallDetail";
import Results from "./pages/Results";
import Settings from "./pages/Settings";

function Protected({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center text-[13px] text-[var(--text-secondary)]">
                Loading workspace…
            </div>
        );
    }
    if (!user) return <Navigate to="/login" replace />;
    return children;
}

function PublicOnly({ children }) {
    const { user, loading } = useAuth();
    if (loading) return null;
    if (user) return <Navigate to="/dashboard" replace />;
    return children;
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Toaster position="bottom-right" closeButton richColors theme="light" />
                <Routes>
                    <Route path="/login" element={<PublicOnly><Login mode="login" /></PublicOnly>} />
                    <Route path="/signup" element={<PublicOnly><Login mode="signup" /></PublicOnly>} />
                    <Route element={<Protected><AppShell /></Protected>}>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/prospects" element={<Prospects />} />
                        <Route path="/scripts" element={<Scripts />} />
                        <Route path="/campaigns" element={<Campaigns />} />
                        <Route path="/campaigns/:id" element={<CampaignDetail />} />
                        <Route path="/calls" element={<Calls />} />
                        <Route path="/calls/:id" element={<CallDetail />} />
                        <Route path="/results" element={<Results />} />
                        <Route path="/settings" element={<Settings />} />
                        <Route path="*" element={<Navigate to="/dashboard" replace />} />
                    </Route>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
